import React from 'react'
import { FaChevronRight, FaChevronDown, FaTaxi, FaSchool, FaHamburger } from 'react-icons/fa'

// Category icon mirrors the desktop myTripsTable.js mapping (0 = taxi, 1 = school, 2 = food).
const categoryIcons = {
   0: FaTaxi,
   1: FaSchool,
   2: FaHamburger
}

/**
 * One row in the "Mine turer" list. Expands to show status/amount/booking
 * details, matching the design.
 */
const TripListItem = ({ trip, expanded, onToggle }) => {
   const VehicleIcon = categoryIcons[trip.category] || FaTaxi

   return (
      <div className="border-b border-gray-100 last:border-b-0">
         <button
            onClick={onToggle}
            className={`w-full flex items-center gap-3 px-4 py-3 text-left focus:outline-none ${
               expanded ? 'bg-gray-100' : ''
            }`}>
            {expanded ? (
               <FaChevronDown className="text-gray-400 flex-shrink-0" size={12} />
            ) : (
               <FaChevronRight className="text-gray-400 flex-shrink-0" size={12} />
            )}

            <div className="flex-1 min-w-0">
               <div className="flex items-center gap-1 text-sm md:text-base text-gray-800 truncate">
                  <span className="font-medium">Til</span> {trip.toAddress}
               </div>
               <div className="flex items-center gap-1 text-sm md:text-base text-gray-500 truncate">
                  <span className="font-medium">Fra</span> {trip.fromAddress}
               </div>
            </div>

            <div className="text-right flex-shrink-0 w-20">
               <div className="text-xs md:text-sm text-gray-400">{trip.pickupDate}</div>
               <div className="text-sm md:text-base font-semibold text-gray-800">{trip.pickupTime}</div>
            </div>

            <VehicleIcon className={`flex-shrink-0 ${trip.vehicleColor}`} size={18} />
         </button>

         {expanded && (
            <div className="grid grid-cols-3 gap-2 bg-gray-200 px-4 py-3 text-sm md:text-base">
               <div>
                  <div className="font-semibold text-gray-800">{trip.status}</div>
                  <div className="text-xs md:text-sm text-gray-500">Status</div>
               </div>
               <div>
                  <div className="font-semibold text-gray-800">{trip.price} kr</div>
                  <div className="text-xs md:text-sm text-gray-500">Beløp</div>
               </div>
               <div>
                  <div className="font-semibold text-gray-800">{trip.bookingNumber}</div>
                  <div className="text-xs md:text-sm text-gray-500">Booking</div>
               </div>
            </div>
         )}
      </div>
   )
}

export default TripListItem
